/**
 * Formats a number as currency. Only EUR is wired up end-to-end in Phase 1,
 * but the currency code is a parameter throughout so adding more currencies
 * later is additive (new ACF choice + this still works unchanged).
 *
 * @param {number} value
 * @param {string} [currency] ISO 4217 currency code, e.g. "EUR".
 * @param {string} [locale]   BCP 47 locale, e.g. "de-DE". Falls back to the browser default.
 * @return {string} The formatted currency string.
 */
export const formatCurrency = ( value, currency = 'EUR', locale ) => {
	const amount = Number.isFinite( value ) ? value : 0;

	return new Intl.NumberFormat( locale || undefined, {
		style: 'currency',
		currency,
	} ).format( amount );
};

/**
 * Just the currency symbol (e.g. "€"), for suffixing a raw numeric input
 * the way the reference tool does — formatCurrency() above is for
 * displaying an already-formatted amount, not for decorating an editable
 * field.
 *
 * @param {string} [currency] ISO 4217 currency code, e.g. "EUR".
 * @param {string} [locale]   BCP 47 locale, e.g. "de-DE". Falls back to the browser default.
 * @return {string} The currency symbol.
 */
export const getCurrencySymbol = ( currency = 'EUR', locale ) => {
	const part = new Intl.NumberFormat( locale || undefined, {
		style: 'currency',
		currency,
	} )
		.formatToParts( 0 )
		.find( ( { type } ) => type === 'currency' );

	return part?.value ?? currency;
};
